module.exports = __webpack_public_path__ + "img/register.06ee7cd5.png";